import { AddToSamplesButton } from '../../components/product-samples/add-to-samples-button-component';
import { ToggleQuickshopSidebar } from '../../components/product-quickshop/toggle-quickshop-component';
import { nextArrow, prevArrow } from '../../utils/slick-theme-settings';

export default (section) => {
  const sliderContainer = section.querySelector('#related-product-slider');
  if (!sliderContainer) {
    return;
  }

  // Create Vue instance
  new Vue({
    el: sliderContainer,
    components: {
      'add-to-samples': AddToSamplesButton,
      'toggle-quickshop': ToggleQuickshopSidebar,
    },
    mounted() {
      // Initialize slider after Vue has mounted
      this.$nextTick(() => {
        this.initializeSlider();
      });
    },
    methods: {
      initializeSlider() {
        const slider = this.$el.querySelector(
          '.multiple-items__product-slider'
        );
        const arrowContainer = slider
          .closest('.product-showcase')
          .querySelector('.product-showcase__header-arrows');

        // Ensure jQuery is available
        if (typeof $ === 'undefined') {
          console.error('jQuery is not loaded');
          return;
        }
        $(slider).slick({
          dots: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          appendArrows: arrowContainer,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      },
    },
  });
};
